import { useEffect, useRef } from 'react';

import UsersAPI from '../api/user';
import { THEMES } from './themes';
import { useTheme } from './ThemeProvider';

export default function ThemeSync({ user }) {
    const { themeKey, setThemeKey } = useTheme();
    const lastSyncedRef = useRef(null);

    useEffect(() => {
        if (!user) {
            lastSyncedRef.current = null;
            return;
        }
        const remote = user.pref_theme;
        if (lastSyncedRef.current === null) {
            // First time we see this user this session — hydrate from server.
            if (remote && THEMES[remote] && remote !== themeKey) {
                setThemeKey(remote);
            }
            lastSyncedRef.current = remote || themeKey;
            return;
        }
        if (themeKey && themeKey !== lastSyncedRef.current) {
            UsersAPI.updatePreferences(
                { theme: themeKey },
                () => { lastSyncedRef.current = themeKey; },
                (err) => { console.log('theme save failed', err); },
            );
        }
    }, [user, themeKey, setThemeKey]);

    return null;
}
